<template>
  <div class="container">
    <div class="row">
      <div class="col-sm-3 text-center">
        <h1>{{ user.fullName }}</h1>
        <!--left col-->

        <div class="text-center logo">
          <img
            :src="Links.DawanLogo"
            alt="Dawan Logo"
          />
          <!-- <input type="file" class="text-center center-block file-upload" /> -->
        </div>
        <br />
      </div>

      <div class="col-sm-4">
        <h1>
          <span class="headline" v-if="!isEditing">{{
            $t("userProfile.viewTitle")
          }}</span>
          <span class="headline" v-if="isEditing">{{
            $t("userProfile.title")
          }}</span>
        </h1>
        <validation-observer ref="observer" v-slot="{ invalid }">
          <v-form @submit.prevent="" class="myform" autocomplete="off">
            <div class="infos-view">
              <div>
                <div class="line">
                  <div class="field">
                    {{ $t("crudUser.hFirstName") }}
                  </div>
                  <div class="data" v-if="!isEditing">
                    {{ user.firstName }}
                  </div>
                  <div class="dataEdit" v-if="isEditing">
                    <validation-provider
                      v-slot="{ errors }"
                      :name="$t('crudUser.hFirstName')"
                      rules="required|alpha"
                    >
                      <v-text-field
                        class="py-0 my-0"
                        v-model="user.firstName"
                        :error-messages="errors"
                        required
                        :solo="!isEditing"
                        :readonly="!isEditing"
                      ></v-text-field>
                    </validation-provider>
                  </div>
                </div>
                <div class="line">
                  <div class="field">
                    {{ $t("crudUser.hLastName") }}
                  </div>
                  <div class="data" v-if="!isEditing">
                    {{ user.lastName }}
                  </div>
                  <div class="dataEdit" v-if="isEditing">
                    <validation-provider
                      v-slot="{ errors }"
                      name="LastName"
                      rules="required|alpha"
                    >
                      <v-text-field
                        class="py-0 my-0"
                        v-model="user.lastName"
                        :error-messages="errors"
                        required
                        :solo="!isEditing"
                        :readonly="!isEditing"
                      ></v-text-field>
                    </validation-provider>
                  </div>
                </div>
              </div>
              <div>
                <div class="line">
                  <div class="field">
                    {{ $t("crudUser.hEmail") }}
                  </div>
                  <div class="data">
                    {{ user.email }}
                  </div>
                </div>
                <div class="line">
                  <div class="field">
                    {{ $t("crudLocation.hCity") }}
                  </div>
                  <div class="data" v-if="!isEditing">
                    {{ getLocation(user.locationId) }}
                  </div>
                  <div class="data" v-if="isEditing && !isAdmin">
                    {{ getLocation(user.locationId) }}
                  </div>
                  <div class="dataEdit" v-if="isEditing && isAdmin">
                    <validation-provider
                      v-slot="{ errors }"
                      name="citys"
                      rules="required"
                    >
                      <v-select
                        class="py-0 my-0"
                        v-model="user.locationId"
                        :items="locations"
                        item-value="id"
                        item-text="city"
                        single-line
                        :error-messages="errors"
                        data-vv-name="citys"
                        required
                      ></v-select>
                    </validation-provider>
                  </div>
                </div>
              </div>
              <div class="line">
                <div class="field">
                  {{ $t("crudUser.hType") }}
                </div>
                <div class="data">
                  {{ user.types.join(", ") }}
                </div>
              </div>
              <div class="line">
                <div class="field">
                  {{ $t("crudUser.hCompany") }}
                </div>
                <div class="data" v-if="!isEditing">
                  {{ user.company }}
                </div>
                <div class="data" v-if="isEditing && !isAdmin">
                  {{ user.company }}
                </div>
                <div class="dataEdit" v-if="isEditing && isAdmin">
                  <validation-provider
                    v-slot="{ errors }"
                    name="companys"
                    rules="required"
                  >
                    <v-select
                      class="py-0 my-0"
                      v-model="user.company"
                      :items="$enumUserCompany"
                      item-value="value"
                      item-text="text"
                      persistent-hint
                      single-line
                      :error-messages="errors"
                      data-vv-name="companys"
                      required
                      :solo="!isEditing"
                      :readonly="!isEditing"
                    ></v-select
                  ></validation-provider>
                </div>
              </div>
            </div>
            <div v-if="errorProfile.checkProfile">
              {{ errorProfile.checkProfile }}
            </div>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                v-if="isEditing"
                color="red darken-1"
                text
                @click="close()"
              >
                {{ $t("userProfile.back") }}
              </v-btn>
              <v-btn
                v-if="isEditing"
                type="submit"
                color="red darken-1"
                :disabled="invalid"
                @click="save()"
              >
                {{ $t("userProfile.save") }}
              </v-btn>

              <v-btn
                color="red darken-1"
                dark
                @click="editProfile()"
                v-if="!isEditing"
              >
                {{ $t("userProfile.update") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import NotificationMessage from "@/components/components-base/notification/NotificationMessage.vue";
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import authService from "@/services/planning/AuthService";
import {
  required,
  email,
  max,
  regex,
  min,
  alpha,
} from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import { updateUserProfileHttp } from "@/services/planning/UserServices.js";
import Links from "@/models/Links"

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "Un {_field_} est obligatoire",
});

extend("max", {
  ...max,
  message: "{_field_} doit étre supérieur a {length} characters",
});

extend("min", {
  ...min,
  message: "{_field_} doit étre inférieur a {length} characters",
});

extend("regex", {
  ...regex,
  message: "{_field_} ne corespond pas",
});

extend("email", {
  ...email,
  message: "Email non valide",
});

extend("alpha", {
  ...alpha,
  message: "{_field_} ne peut contenir que des lettres.",
});

export default {
  mixins: [validationMixin],

  components: {
    NotificationMessage,
    ValidationProvider,
    ValidationObserver,
  },

  data() {
    return {
      user: {},
      valid: true,
      email: "",
      name: "",
      initialUser: {},
      isEditing: false,
      isAdmin: false,
      errorProfile: { checkProfile: null },
      inputText: [
        (v) => !!v || i18n.t("errorFrontEnd.requiredField"),
        (v) =>
          /^[ A-Za-z0-9/-]*$/.test(v) ||
          i18n.t("errorFrontEnd.specialCharacters"),
      ],
      Links: Links,
    };
  },
  created() {
    this.user = authService.getUser();

    if (authService.isAuth() && authService.userHasSomeRoles(["ADMINISTRATIF"]))
      this.isAdmin = true;
  },
  computed: {
    ...mapGetters("locationModule", { locations: "getLocations" }),
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  methods: {
    ...mapActions("notificationModule", ["showNotification"]),
    ...mapActions("userModule", ["editUser", "editUserProfile"]),

    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    getLocation(locationId) {
      var userLocation = this.locations.find((l) => l.id === locationId);
      if (userLocation != null) {
        this.userCity = userLocation.city;
        return this.userCity;
      }
    },
    close() {
      this.isEditing = !this.isEditing;
      this.user = authService.getUser();
    },
    editProfile() {
      this.isEditing = !this.isEditing;
      this.errorProfile.checkProfile = "";
    },
    async save() {
      if (this.user) {
        updateUserProfileHttp(this.user).then((response) => {
          if (response.status != 200) {
            this.errorProfile.checkProfile = this.$t("userProfile.errorUpdate");
          } else {
            this.errorProfile.checkProfile = this.$t("userProfile.doneUpdate");
            (this.user = response.data),
              (this.user.fullName = `${this.user.firstName} ${this.user.lastName}`);
            authService.setUser(this.user);
            this.isEditing = false;
          }
        });
      }
    }, // TO REVIEW
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;

      reader.onload = (e) => {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage: function (e) {
      this.image = "";
    },
  },
};
</script>

<style lang="scss">
.myform {
  display: block;
  flex-direction: column;
  .theme--light.v-select .v-select__selection--disabled {
    color: rgba(0, 0, 0, 0.87);
  }
}

.infos-view {
  padding: 0 10px 0 0;
  display: flex;
  flex-direction: column;
  font-size: 1.2rem;
  height: 100%;
  margin: 20px 10px 0;
  overflow-y: scroll;

  .line {
    display: flex;
    justify-content: space-between;
    padding: 0 0 15px;
    margin: 0 0 15px;
    border-bottom: 1px solid var(--border-color);
    .dataEdit {
      width: 200px;
    }
  }

  .field {
    color: rgb(155, 155, 155);
  }
  .data {
    display: flex;
  }

  .v-input {
    font-size: 19px;
  }

  .logo {
    display: block;
  }
}
</style>
